<template>
    <BaseLayout>
      <div class="ol-addcart" id="copy_voucher_url" hidden="true">
        <i class=""></i> Kode Voucher Berhasil tersimpan
      </div>
      <section class="ol-promotion-info" id="header-promotion">
        <div class="ol-wrapper ol-wrapper--large">
          <div class="ol-promotion-info__list add-fix">
            <div class="ol-promotion-info__list-item" >
              <div class="ol-promotion-info__list-item-wrapper">
                <a @click.prevent="scrollToHash('retail')" href="#retail" class="scrollLink">
                  <div class="row no-gutters">
                    <div class="col-md-12 col-lg-2">
                      <img :src="require('@/assets/images/promotion/retail.png')">
                    </div>
                    <div class="col-md-12 col-lg-10 ol-promotion-label">
                      <span style="color:#1F2B47">Retail</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="ol-promotion-info__list-item" >
              <div class="ol-promotion-info__list-item-wrapper">
                <a @click.prevent="scrollToHash('website')" href="#website" class="scrollLink">
                  <div class="row no-gutters">
                    <div class="col-md-12 col-lg-2">
                      <img :src="require('@/assets/images/promotion/website.png')">
                    </div>
                    <div class="col-md-12 col-lg-10 ol-promotion-label">
                      <span style="color:#1F2B47">Website</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="ol-promotion-info__list-item" >
              <div class="ol-promotion-info__list-item-wrapper">
                <a @click.prevent="scrollToHash('marketplace')" href="#marketplace" class="scrollLink">
                  <div class="row no-gutters">
                      <div class="col-md-12 col-lg-2">
                        <img :src="require('@/assets/images/promotion/marketplace.png')">
                      </div>
                      <div class="col-md-12 col-lg-10 ol-promotion-label">
                        <span style="color:#1F2B47">Marketplace</span>
                      </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="ol-promotion-info__list-item" >
              <div class="ol-promotion-info__list-item-wrapper">
                <a @click.prevent="scrollToHash('interior')" href="#interior" class="scrollLink">
                  <div class="row no-gutters">
                    <div class="col-md-12 col-lg-2">
                      <img :src="require('@/assets/images/promotion/interior.png')">
                    </div>
                    <div class="col-md-12 col-lg-10 ol-promotion-label">
                      <span style="color:#1F2B47">Interior</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
        
      <div class="break-promotion-top"></div>
      <div class="ol-wrapper ol-wrapper--large">
          <div class="title-div-content" >
              <h2 class="heading-content font-moreversary">MOREVERSARY 3th</h2>
              <span class="sub-heading-content">#3uforiaBelanja</span>
          </div>
          <BannerPromotion :banners="bannerHead" :clickable="true" />
      </div>
      <div class="break-24"></div>

      <div class="ol-wrapper ol-wrapper--large" id="retail">
          <div class="title-div-content">
              <h2 class="heading-content" style="color:#364B7B">MORE Retail</h2>
              <span class="sub-heading-content">Gebyar Ulang Tahun di MORE Retail Experience!</span>
          </div>
          <div class="title-moreversary heading-content">PROMO RETAIL</div>
          <ul class='timeline'>
            <li class='work'>
              <input class='radio' id='work5' name='works' type='radio' checked>
              <div class="relative">
                <label for='work5'>Night Shopping Discount Up To 80%
                  </label>
                <span class='date'>7 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio' id='work4' name='works' type='radio'>
              <div class="relative">
                <label for='work4'>Weekend Deals 33% + 33% & 33 Produk</label>
                <span class='date'>13-14 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio' id='work3' name='works' type='radio'>
              <div class="relative">
                <label for='work3'>More Birthday Gift</label>
                <span class='date'>17-21 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio' id='work2' name='works' type='radio'>
              <div class="relative">
                <label for='work2'>MEGA FLASHSALE Moreversary</label>
                <span class='date'>27-28 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
          </ul>
          <div class="title-moreversary heading-content">GEBYAR EVENT</div>
          <div class="break-16"></div>
          <div class="wrapper-event">
            <div>
              <div class="row no-gutters" >
                <div class="col-6">
                    <img :src="require('@/assets/images/MOREVERSARY/Coming-Soon.jpg')"  width="100%" height="100%" style="border-radius: 8px;"/>
                </div>
                <div class="col-6">
                    <div class="content-location">
                        <div class="content-location-detail" style="text-align:left">
                            <h4 style="font-weight: 800;line-height: 34px;color: #141414;">Coming Soon</h4>
                            <!-- <div class="content-location-info" >
                                <table>
                                <tr>
                                    <td style="padding:4px;"><img :src="require('@/assets/images/interior/location.png')"  width="16" height="16" style="vertical-align: top;"/></td>
                                    <td style="padding:4px;">-</td>
                                </tr>
                                <tr>
                                    <td style="padding:4px;"><img :src="require('@/assets/images/interior/time.png')"  width="16" height="16" /></td>
                                    <td style="padding:4px;">-</td>
                                </tr>
                                </table>
                            </div>
                            <div style="margin-top:16px;margin-bottom:16px;">
                                <a class="content-location-button-1" href="https://maps.app.goo.gl/y8WwqUPFLWdjVzTg6" target="_blank">Daftar Sekarang</a>
                            </div> -->
                        </div>
                        
                    </div>
                </div>
              </div>
            </div>
            <div>
              <div class="row no-gutters" >
                <div class="col-6">
                    <img :src="require('@/assets/images/MOREVERSARY/Coming-Soon.jpg')"  width="100%" height="100%" style="border-radius: 8px;"/>
                </div>
                <div class="col-6">
                    <div class="content-location">
                        <div class="content-location-detail" style="text-align:left">
                            <h4 style="font-weight: 800;line-height: 34px;color: #141414;">Coming Soon</h4>
                            <!-- <div class="content-location-info" >
                                <table>
                                <tr>
                                    <td style="padding:4px;"><img :src="require('@/assets/images/interior/location.png')"  width="16" height="16" style="vertical-align: top;"/></td>
                                    <td style="padding:4px;">-</td>
                                </tr>
                                <tr>
                                    <td style="padding:4px;"><img :src="require('@/assets/images/interior/time.png')"  width="16" height="16" /></td>
                                    <td style="padding:4px;">-</td>
                                </tr>
                                </table>
                            </div>
                            <div style="margin-top:16px;margin-bottom:16px;">
                                <a class="content-location-button-1" href="https://maps.app.goo.gl/y8WwqUPFLWdjVzTg6" target="_blank">Daftar Sekarang</a>
                            </div> -->
                        </div>
                        
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="break-16"></div>
          <div class="row no-gutters" style="background: #F6F7F9;" >
            <div class="col-md-12 col-lg-6">
                <div class="content-location">
                    <div class="content-location-detail">
                        <h4 style="font-weight: 800;line-height: 34px;color: #141414;">Showroom MORE Furniture</h4>
                        <div class="content-location-info">
                            <table>
                            <tr>
                                <td style="padding:4px;"><img :src="require('@/assets/images/interior/location.png')"  width="16" height="16" style="vertical-align: top;"/></td>
                                <td style="padding:4px;">Jl. Mayjen HR. Muhammad No.33, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226</td>
                            </tr>
                            <tr>
                                <td style="padding:4px;"><img :src="require('@/assets/images/interior/time.png')"  width="16" height="16" /></td>
                                <td style="padding:4px;">09:00 - 21:00</td>
                            </tr>
                            <tr>
                                <td style="padding:4px;"><img :src="require('@/assets/images/interior/phone.png')"  width="16" height="16" /></td>
                                <td style="padding:4px;">+62 811 306 6171</td>
                            </tr>
                            </table>
                        </div>
                        <div style="margin-top:16px;margin-bottom:16px;">
                            <a class="content-location-button-1" href="https://maps.app.goo.gl/y8WwqUPFLWdjVzTg6" target="_blank">Lihat Brosur</a>
                            <a class="content-location-button-2" href="https://api.whatsapp.com/send?phone=628113066171" target="_blank">Whatsapp</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <img :src="require('@/assets/images/interior/Facade-More-521x316.jpg')"  width="100%" height="100%" class="image-showroom"/>
            </div>
          </div>
      </div>

      <div class="break-24"></div>
      <div class="ol-wrapper ol-wrapper--large" id="website">
          <div class="title-div-content">
              <h2 class="heading-content" style="color:#364B7B">Hanya di Website MORE</h2>
              <span class="sub-heading-content">Pengalaman terbaik berbelanja di Website MORE!</span>
          </div>
          <BannerBottomLoading v-if="loading" />
          <BannerTop v-else :banners="bannerTop" />
          <div class="break-24"></div>
          <div class="break-16"></div>
          <div class="title-moreversary heading-content">PROMO RETAIL</div>
          <ul class='timeline'>
            <li class='work'>
              <input class='radio-website' id='work6' name='websites' type='radio' checked>
              <div class="relative-website">
                <label for='work6'>Kombo Hemat & Tebus Murah
                  </label>
                <span class='date'>1-6 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work7' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work7'>Spesial Tamabahan Diskon 10%</label>
                <span class='date'>7 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work8' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work8'>Tamabahan Diskon 10% & Tebus Murah & Kombo Hemat</label>
                <span class='date'>8-14 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work9' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work9'>Kombo Hemat & Tebus Murah</label>
                <span class='date'>15-20 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work10' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work10'>Tamabahan Diskon 10% </label>
                <span class='date'>20-21 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work11' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work11'>Kombo Hemat & Tebus Murah </label>
                <span class='date'>22-26 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work12' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work12'>MEGA FLASHSALE </label>
                <span class='date'>27-28 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
            <li class='work'>
              <input class='radio-website' id='work13' name='websites' type='radio'>
              <div class="relative-website">
                <label for='work13'>Kombo Hemat & Tebus Murah </label>
                <span class='date'>29-31 Juli 2024</span>
                <span class='circle'></span>
              </div>
              <div class='content'>
                <p class="extra-content">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odio ea necessitatibus quo velit natus cupiditate qui alias possimus ab praesentium nostrum quidem obcaecati nesciunt! Molestiae officiis voluptate excepturi rem veritatis eum aliquam qui laborum non ipsam ullam tempore reprehenderit illum eligendi cumque mollitia temporibus! Natus dicta qui est optio rerum.
                </p>
              </div>
            </li>
          </ul>
          <div class="wrapper-marketplace">
            <a href="promotion#voucher"><div class="promo-website">Voucher s.d. 200Rb</div></a>
            <a href="promotion#gift"><div class="promo-website">Gratis Hadiah</div></a>
            <a href="promotion#combo"><div class="promo-website">Kombo Hemat</div></a>
          </div>
      </div>
      <FlashsaleGroup id="flashsale" style="margin-top:8px" />
      
      <!-- <section class="ol-home-type-product" id="gift">
          <div class="ol-wrapper ol-wrapper--large">
          <div class="row no-gutters">
              <div class="col-6">
              <h2 class="ol-section-title">
                  <img :src="require('@/assets/images/promotion/free-produk-black.png')" width="17" style="margin-right:8px"><span>Gratis Hadiah</span>
                  <i></i>
              </h2>
              </div>
              <div class="col-6" style="text-align:right;">
              <div style="margin-top:5px;">
                  <a href="/products/q=gratis" style="color:#C13B37"><b>Lihat Semua</b> <i class="fa fa-arrow-right"></i></a>
              </div>
              </div>
          </div>
          
          <div class="ol-product-content ol-product-related">
              <ProductLoader wrapclass="ol-product-content__center-list" :page="2" :qty="5" v-if="loadingFrees"/>
              <CarouselProductFree :products="frees" v-if="!loadingFrees" carouselKey="productFrees" />
          </div>
          </div>
      </section> -->

      <div class="break-24"></div>
      <div class="ol-wrapper ol-wrapper--large margin-top" id="marketplace">
          <div class="row no-gutters" style="background: #F6F7F9;">
            <div class="col-md-12 col-lg-6">
                <img :src="require('@/assets/images/interior/Facade-More-521x316.jpg')"  width="100%" height="100%"  style="border-radius: 8px;"/>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="content-location">
                    <div class="content-location-detail">
                        <h2 class="heading-content" style="color:#364B7B">Marketplace Deal</h2>
                        <span class="sub-heading-content">Pengalaman menarik di semua platform E-commerce</span>
                        <div class="break-16"></div>
                        <div class="wrapper-marketplace">
                          <div style="border: 0.5px solid #ADB5C2;border-radius: 8px;padding:8px">
                              <a href="https://shopee.co.id/morefurniture.id" target="_blank">
                                <div>
                                  <img :src="require('@/assets/images/shopee.png')"  width="50%" height="50%" />
                                </div>
                              </a>
                          </div>
                          <div style="border: 0.5px solid #ADB5C2;border-radius: 8px;padding:8px">
                              <a href="https://www.tokopedia.com/morefurniture-id" target="_blank">
                                <div>
                                  <img :src="require('@/assets/images/tokopedia.png')"  width="50%" height="50%" />
                                </div>
                              </a>
                          </div>
                          <div style="border: 0.5px solid #ADB5C2;border-radius: 8px;padding:8px">
                            <a href="https://www.tiktok.com/@morefurniture.id" target="_blank">
                              <div>
                                <img :src="require('@/assets/images/tiktok.png')"  width="50%" height="50%" />
                              </div>
                            </a>
                          </div>
                        </div>
                    </div>
                    
                </div>
            </div>
          </div>
      </div>
      <div class="break-16"></div>
    </BaseLayout>
  </template>
  
  <script>
  import BaseLayout from '@/components/landing/BaseLayout';
  import BannerBottomLoading from '@/components/loading/BannerBottomLoading';
  import BannerTop from '@/components/home/BannerTop';
  import BannerPromotion from '@/components/home/BannerPromotion';
  import ProductLoader from '@/components/loading/product/Content';
  import CarouselProduct from '@/components/home/CarouselProduct';
  import CarouselProductFree from '@/components/home/CarouselProductFree';
  import CarouselProductCombo from '@/components/home/CarouselProductCombo';
  import FlashsaleGroup from '@/components/product/FlashsaleGroup';
  import ProductListGroup from '@/components/product/ProductListGroup';
  import { mapActions, mapGetters } from 'vuex';
  
  
  export default {
    name: 'Moreversary',
    metaInfo() {
      return {
        link: [
          {rel: 'canonical', href: window.location.origin+this.$route.fullPath}
        ]
      }
    },
    components: {
      BaseLayout,
      BannerBottomLoading,
      BannerTop,
      BannerPromotion,
      ProductLoader,
      CarouselProduct,
      CarouselProductFree,
      FlashsaleGroup,
      ProductListGroup,
      CarouselProductCombo,
    },
    data() {
      return {
        loading:false,
        loadingBottom:false,
        loadingLastPaket:false,
        loadingFrees:false,
        loadingCombos:false,
        loadingPakets:false,
        loadingLastPaket:true,
        bannerHead:[
            {
              link_banner:"#",
              mobile:require('@/assets/images/MOREVERSARY/moreversary_1.jpg'),
              web:require('@/assets/images/MOREVERSARY/moreversary_1.jpg')
            },
            {
              link_banner:"#",
              mobile:require('@/assets/images/MOREVERSARY/moreversary_1.jpg'),
              web:require('@/assets/images/MOREVERSARY/moreversary_1.jpg')
            },
            {
              link_banner:"#",
              mobile:require('@/assets/images/MOREVERSARY/moreversary_1.jpg'),
              web:require('@/assets/images/MOREVERSARY/moreversary_1.jpg')
            },
            {
              link_banner:"#",
              mobile:require('@/assets/images/MOREVERSARY/moreversary_1.jpg'),
              web:require('@/assets/images/MOREVERSARY/moreversary_1.jpg')
            },
        ]
      }
    },
    computed: {
      ...mapGetters('product/list', ['products', 'topProducts']),
      ...mapGetters('home', ['bannerTop', 'productGroups']),
      ...mapGetters('auth', ['authenticated']),
      ...mapGetters('promotion', ['frees', 'combos','pakets']),
      ...mapGetters("product/detail", ['voucher']),
      ...mapGetters('profile/product', ['lastSeen','lastPaket']),
    },
    methods: {
      ...mapActions('profile/product', ['saveProductHistory','fetchLastSeen','fetchLastPaket']),
      ...mapActions('home', ['fetchProductGroups', 'getBanner']),
      ...mapActions('product/list', ['fetchProducts', 'fetchTopProducts']),
      ...mapActions('promotion', ['fetchFrees', 'fetchCombos', 'fetchPakets']),
      ...mapActions("product/detail", ['fetchVoucher']),
      initSlickRecomendation() {
        if($('.ol-home-group-list').hasClass("slick-initialized")) $(".ol-home-group-list").slick('unslick');
        $(".ol-home-group-list").slick({
          slidesToScroll: 1,
          swipeToSlide: true,
          verticalSwiping: false,
          slidesToShow: 5,
          dots: false,
          autoplay: true,
          autoplaySpeed: 5e3,
          arrows: !0,
          pauseOnFocus: !1,
          infinite: false,
          speed: 500,
          fade: !1,
          responsive: [{
            breakpoint: 1500,
            settings: {
              slidesToShow: 5
            }
          }, {
            breakpoint: 1160,
            settings: {
              slidesToShow: 4
            }
          }, {
            breakpoint: 748,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 530,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 481,
            settings: {
              slidesToShow: 2
            }
          }]
        });
      },
      async getLastSeen(){
          this.loadingLastPaket = true;
          // if(this.authenticated) await this.saveProductHistory();
          await this.fetchLastPaket();
          // await this.fetchPakets();
  
          this.loadingLastPaket = false;
      },
      scrollToHash(hash) {
        hash = hash.replace('#', '');
        const h = document.getElementsByTagName('header')[0].offsetHeight + document.getElementById('header-promotion').offsetHeight;
        const el = document.getElementById(hash);
        if(el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - h;
          window.scrollTo({top: top, behavior: 'smooth'});
          this.$router.push({hash: hash});
        }
      },
      copyNumber(value) {
          navigator.clipboard.writeText(value).then(function () {
            $('#copy_voucher_url').prop('hidden',false);
            setTimeout(() => { $('#copy_voucher_url').prop('hidden',true); }, 1500);
          }, function () {
            // alert('Failure to copy. Check permissions for clipboard')
          });
        },
    },
    async created() {
      this.$store.commit('transaction/checkout/setOrder', null);
    },
    updated() {
      // if(this.bannerTop) this.jqSlickTopBanner();
      // if(this.bannerBottom) this.jqSlickBotttomBanner();
    },
    async mounted() {
      this.loading = true;
      this.loadingBottom = true;
      this.loadingFrees = true;
      this.loadingCombos = true;
      this.loadingPakets = true;
  
      await Promise.all([
        this.getBanner('1'),
        this.getBanner('2'),
        this.fetchVoucher(),
        this.fetchProductGroups(),
        this.fetchFrees(),
        this.fetchCombos(),
      ]);
      await this.getLastSeen();
  
      this.initSlickRecomendation();
  
      this.loading = false;
      this.loadingBottom = false;
      this.loadingFrees = false;
      this.loadingCombos = false;
      this.loadingPakets = false;
  
      if(this.$route.hash) {
        this.scrollToHash(this.$route.hash);
      }

      
    },
    watch:{
      bannerTop: function(value){
        this.loading = false;
      },
      bannerBottom: function(value){
        this.loadingBottom =false;
      },
    },
  }
  </script>
  
  <style scoped lang="css">
  @import '../../assets/css/coupon.css';
  @import '../../assets/css/bootstrap.css';
  @import '../../assets/css/timeline.css';
  
  .ol-home-menu{
    padding-top:24px;
  }
  
  @media (max-width: 768px) {
    .ol-home-menu{
      padding-top:0px;
    }
  }

  
.content-location{
    padding: 20px;height: 100%;display: flex;align-items: center;
}

.content-location-detail{
    padding: 0px 20px;
}

.content-location-info{
    margin-top:8px;font-weight: 500;font-size: 16px;color: #424242;
}

.content-location-button-1{
    font-weight: 600;background: #364B7B;border-radius: 4px;border:1px solid #364B7B;color:#FFF;padding:8px 16px;font-size:14px;margin-right:8px;
}
.content-location-button-2{
    font-weight: 600;background: white;border-radius: 4px;border:1px solid #364B7B;color:#364B7B;padding:8px 16px;font-size:14px;margin-right:8px;
}

@media (max-width: 768px) {
    

    .content-location{
        padding: 8px;height: 100%;display: flex;align-items: center;
    }
    
    .content-location-detail{
        padding: 0px 8px;
    }
    .content-location-info{
        margin-top:8px;font-weight: 500;font-size: 12px;color: #424242;
    }
    .content-location-button-1{
        font-weight: 600;background: white;border-radius: 4px;
        border:1px solid #364B7B;color:#364B7B;padding:8px 16px;
        font-size:12px;margin-right:8px;
        margin-bottom: 8px;
        margin-right:8px;
    }
    .content-location-button-2{
        font-weight: 600;background: white;border-radius: 4px;
        border:1px solid #364B7B;color:#364B7B;padding:8px 16px;
        font-size:12px;margin-right:8px;
        margin-bottom: 8px;
    }

    
}

.wrapper-marketplace {
  display: grid;
  grid-template-columns: repeat(3, 1.2fr);
  /* grid-auto-rows: 45%; */
  column-gap: 20px;
  row-gap: 20px;
  text-align: center;
}

.wrapper-event {
  display: grid;
  grid-template-columns: repeat(2, 1.2fr);
  /* grid-auto-rows: 45%; */
  column-gap: 20px;
  row-gap: 20px;
  text-align: center;
}


.title-moreversary{
  color:white;
  background-image: url('https://asset.morefurniture.id/MORE/asset/background-moreversary.png');
  font-size: 18px;
  background-size: cover;
  border-radius: 8px;
  padding: 8px;
  font-weight: bold;
}

.promo-website{
  color:white;
  background-image: url('https://asset.morefurniture.id/MORE/asset/background-moreversary.png');
  font-size: 18px;
  background-size: cover;
  border-radius: 8px;
  padding: 8px;
  font-weight: bold;
}

.image-showroom{
  display: block;
}
@media (max-width: 768px) {
  .wrapper-event {
    display: grid;
    grid-template-columns: repeat(1, 1.2fr);
    /* grid-auto-rows: 45%; */
    column-gap: 20px;
    row-gap: 20px;
    text-align: center;
  }


  .title-moreversary{
    color:white;
    background-image: url('https://asset.morefurniture.id/MORE/asset/background-moreversary.png');
    font-size: 14px;
    background-size: cover;
    border-radius: 8px;
    padding: 8px;
    font-weight: bold;
  }

  .image-showroom{
    display: none;
  }

  .promo-website{
    color:white;
    background-image: url('https://asset.morefurniture.id/MORE/asset/background-moreversary.png');
    font-size: 16px;
    background-size: cover;
    border-radius: 8px;
    padding: 8px;
    font-weight: bold;
  }

}

.ol-home-menu-list-item{
  padding: 8px !important;
  border-radius: 8px;
}

.font-moreversary{
  background: linear-gradient(178deg, #364B7B 11.93%, #DC5F56 45.1%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
}

.ol-promotion-info{
  z-index:200!important;
}
</style>